<template>
  <div class="formContent">
    <div class="form">
      <ul class="header">
      </ul>
      <div class="table">
        <table class="tableTitle">
          <tr class="titleTr">
            <th class="titleTh1">时间</th>
            <th class="titleTh2">地点</th>
            <th class="titleTh3">名额</th>
            <th class="titleTh4">报名截止时间</th>
            <th class="titleTh5">课程</th>
          </tr>
          <tr class="titleTd">
            <td>{{ areaList.activeDate }}</td>
            <td>{{ areaList.activeAddr }}</td>
            <td class="balance">{{ areaList.activeUserResidue }}</td>
            <td class="deadline">{{ areaList.endDate }}</td>
            <td>{{ areaList.activeName }}</td>
          </tr>
        </table>
      </div>
      <van-form @submit="onSubmit" ref="form">
        <van-field label="姓名" v-model="name" :rules="[{ required: true, message: '请填写用户名' }]" required clearable
          :border="false" left-icon="manager" />
        <!-- <div v-for="(item, index) in peers " style="position: relative;">
          <van-field :label="'同行人' + (index + 1) + '姓名'" v-model="peers[index]" clearable :border="false"
            left-icon="friends-o" />
          <div style="position: absolute;right: 16%;top: 57%;"><van-icon @click="onAdd" color="red" name="plus" /></div>
          <div style="position: absolute;right: 11%;top: 57%;"><van-icon @click="onDelete(index)" color="red"
              name="minus" /></div>
        </div> -->
        <van-field label="单位名称" v-model="company" :rules="[{ required: true, message: '请填写单位' }]" required clearable
          :border="false" left-icon="newspaper-o" />
        <van-field label="手机" v-model="phone" type="number"
          :rules="[{ required: true, message: '请填写手机号码' }, { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码' }]"
          required clearable maxlength="11" :border="false" left-icon="phone" />
        <van-field label="工作邮箱" v-model="email"
          :rules="[{ required: true, message: '请填写工作邮箱' }, { pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/, message: '请填写正确的邮箱' }]"
          required clearable :border="false" left-icon="envelop-o" class="custom-field" />
        <radio v-if="areaList.type !=4" name="是否付费(以签订合同约定为准，具体信息可咨询销售)" :radioValueList="companyTypeList"
          @radioChange="companyTypeChange">
        </radio>
        <van-field label="合同订单号" v-if="companyType == 0 && areaList.type !=4" v-model="orderno"
          :rules="[{ required: true, message: '请填写合同订单号' }]" required clearable :border="false" left-icon="column" />
        <div style="padding: 16px;">
          <van-button block color="#e81a26" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import radio from '../components/radios.vue';
import checkBox from '../components/checkBox.vue';
import { queryByIdActive, addUserForm } from '../api/forms';
import { Notify, Dialog } from 'vant';
export default {
  components: {
    radio,
    checkBox
  },
  data() {
    return {
      openId: this.$cookies.get("openId") || "",
      name: this.$cookies.get("username") || '',
      phone: this.$cookies.get("phone") || '',
      company: this.$cookies.get("department") || '',
      email: this.$cookies.get("email") || '',
      peers: [''],//同行人
      orderno: '',//订单号
      companyTypeList: ['是', '否'], // 是否付费
      companyType: 0,//是否付费
      id: this.$route.query.id || "",
      areaList: {},//会议列表,
    }
  },
  methods: {
    getQueryByIdActive() {
      queryByIdActive(this.id).then((res) => {
        if (res.data != null) {
          this.areaList = res.data
        }
        else {
          return Notify({ type: 'warning', message: res.msg, duration: 6000 });
        }
      })
    },
    // 是否付费
    companyTypeChange(val) {
      if (val == '是') {
        this.companyType = 1;
      }
      else {
        this.companyType = 0;
      }
    },
    //添加
    onAdd() {
      let hasEmptyString = this.peers.some(item => typeof item === 'string' && item.trim() === '');
      if (hasEmptyString) {
        return Notify({ type: 'warning', message: '请补全同行人，再来尝试添加新的同行人吧', duration: 6000 });
      }
      else if (this.peers.length < 4) {
        this.peers.push('');
      }
      else {
        Notify({ type: 'warning', message: '最多添加4位同行人', duration: 6000 });
      }

    },

    //删除
    onDelete(index) {
      if (this.peers.length <= 1) {
        Notify({ type: 'warning', message: '已经到底不能再清空啦', duration: 6000 });
      }
      //根据index删除数组
      else {
        this.peers.splice(index, 1);
      }
    },
    // 提交按钮
    onSubmit() {
      //如果同行人大于了名额
      if (this.peers.filter(item => item !== "").length + 1 > this.areaList.activeUserResidue) {
        Dialog.alert({
          title: '名额人数不足',
          message: `剩余名额${this.areaList.activeUserResidue}人`,
        }).then(() => {
          // on close
        });
      }
      else {
        let data = {
          department: this.company,// 单位名称
          email: this.email,    // 邮箱
          username: this.name, // 姓名
          openid: this.openId,// 微信openid
          phone: this.phone, // 电话
          contractNo: this.orderno,// 订单号
          peers: this.peers.filter(item => item !== ""),//同行人
          wxHead: this.$cookies.get("avatar"),
          wxName: this.$cookies.get("nickName"),
          activeId: this.id,
          activeName: this.areaList.activeName,
          pay: this.companyType
        }
        addUserForm(data).then((res => {
          console.log(res);
          if (res.code === 200) {
            this.getQueryByIdActive();
            this.$cookies.set("email", data.email)
            this.$cookies.set("username", data.username)
            this.$cookies.set("department", data.department)
            this.$cookies.set("phone", data.phone)
            // this.$cookies.set("userInfo", JSON.stringify(data))
            Dialog.alert({
              message: `报名成功`,
            }).then(() => {
              // this.$router.push(`/Download?openId=${this.openId}&articleType=${this.id}&pay=${this.companyType}`);
              this.$router.push(`/pdfDownLoad?openId=${this.openId}&articleType=${this.id}&pay=${this.companyType}`);
            });
          }
          else if (res.code === 10008) {
            this.getQueryByIdActive();
            Notify({ type: 'warning', message: `名额不足无法添加，名额仅剩${this.areaList.activeUserResidue}人`, duration: 6000 });
          }
          else {
            this.getQueryByIdActive();
            Dialog.alert({
              message: '您已报名，点击下载邀请函？',
            }).then(() => {
              this.$router.push(`/pdfDownLoad?openId=${this.openId}&articleType=${this.id}&pay=${this.companyType}`);
              // this.$router.push("/State?openId=" + this.openId);
            });
          }
        }))
      }

    }
  },
  mounted() {
    this.getQueryByIdActive();
  }
};
</script>
<style lang="scss" scoped>
.formContent {
  background-repeat: repeat;
  background-size: 100% 100%;
  height: 100vh;
  overflow-y: auto;

  .form {
    // min-height: 100vh;
    background: url('../assets/banner3.png') no-repeat;
    background-size: 100% auto;

    .header {
      text-align: center;
      position: relative;
      padding-top: 37%;
      letter-spacing: 2px;

      li:nth-child(1) {
        font-size: 27px;
        margin-bottom: 10px;
        color: #7F8C8D;
        font-weight: bold;
      }

      li:nth-child(2),
      li:nth-child(3) {
        font-size: 14px;
        color: #525252;
        line-height: 20px;
        opacity: .8;
      }
    }

    .table {
      margin-top: 70px;
      padding: 0 16px;

      .tableTitle {
        font-family: 'FZLTXHJW';
        width: 100%;

        .titleTr {
          white-space: nowrap;
          /* 防止文字换行 */
          font-size: 12px;
          display: flex;
          // justify-content: space-between;

          th {
            background-color: #E81A26;
            color: #fff;
            border-radius: 10px;
            padding: 3px 10px;
            font-weight: 400;
          }

          .titleTh2 {
            margin-left: 25px;
          }

          .titleTh3 {
            margin-left: 10px;
          }

          .titleTh4 {
            margin-left: 10px;
          }

          .titleTh5 {
            margin-left: 10px;
          }
        }

        .titleTd {
          display: flex;
          align-items: center;
          font-size: 10px;

          td {
            margin-right: 5px;
            margin-top: 15px;
            white-space: nowrap;
          }

          .balance {
            margin-left: 25px;
          }

          .deadline {
            margin-left: 35px;
          }
        }
      }
    }

    .custom-field ::v-deep .van-field__left-icon {
      position: absolute;
      top: 48px !important;
      left: 25px;
    }

    ::v-deep .van-form {
      margin-top: .4%;
      padding: 15px 0 0;
      background: #fff;
      opacity: .96;


      .van-cell {
        flex-direction: column;

        // 图标
        .van-field__left-icon {
          position: absolute;
          top: 48px;
          left: 25px;
        }



        .van-icon:before {
          font-size: 20px;
          color: #768bab;
        }

        .van-field__label {
          margin-bottom: 5px;
          margin-right: 0;
          width: 100%;

          span {
            font-size: 14px;
            letter-spacing: 2px;
          }
        }

        // 输入的内容
        .van-field__body {
          border: 1px #d3d3d3 solid;
          padding: 0 7px 0 35px;

          .van-field__control {
            font-size: 14px;
            line-height: 40px;
          }

          .van-icon:before {
            font-size: 16px !important;
          }
        }
      }

      .radio {

        .van-icon:before {
          font-size: 10px !important;
          color: #fff;
        }

        .van-cell__title.van-field__label {
          width: auto;
        }

        .van-field__body {
          border: none;
          padding: 0;

          .van-radio {
            margin: 10px 0 0;
          }
        }
      }

      .van-checkbox {
        margin: 15px 0 0;

        .van-checkbox__icon--checked .van-icon {
          background: #224477;
          border: 1px #224477 solid;
        }
      }

      .area,
      .detailArea,
      .tutor,
      .companyTypeOther {

        .van-field__body {
          padding: 0 7px;
        }

        .van-cell__title.van-field__label {
          width: auto;
        }
      }
    }
  }
}
</style>